/* Shirtfight storefront helpers: quick add on product cards, AJAX add to cart, toast and cart bubble refresh. */
(function () {
  if (window.SFStore) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastEl, toastTimer;

  function toast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sf-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('sf-toast--error', !!isError);
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (!isError) {
      var a = document.createElement('a');
      a.href = root + 'cart';
      a.textContent = 'View cart';
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4500);
  }

  function refreshBubble() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('sf:cart-updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () {});
  }

  function add(id, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add this item.');
        return data;
      });
    }).then(function (data) {
      return refreshBubble().then(function () { return data; });
    });
  }

  // Product cards: open and close the size picker, add the chosen size
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sf-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('[data-sf-card]');
      document.querySelectorAll('[data-sf-card].is-open').forEach(function (c) { if (c !== card) c.classList.remove('is-open'); });
      card.classList.add('is-open');
      open.setAttribute('aria-expanded', 'true');
      var firstSize = card.querySelector('.sf-card__size:not([disabled])');
      if (firstSize) firstSize.focus({ preventScroll: true });
      return;
    }
    var close = e.target.closest('[data-sf-close]');
    if (close) {
      e.preventDefault();
      var c = close.closest('[data-sf-card]');
      c.classList.remove('is-open');
      var btn = c.querySelector('[data-sf-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
      return;
    }
    var addBtn = e.target.closest('[data-sf-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      var label = addBtn.textContent;
      add(addBtn.getAttribute('data-sf-add'), 1)
        .then(function (data) {
          var item = data.items && data.items[0];
          toast((item ? item.product_title + (item.variant_title ? ' (' + item.variant_title + ')' : '') : 'Item') + ' added');
          var card = addBtn.closest('[data-sf-card]');
          if (card) card.classList.remove('is-open');
        })
        .catch(function (err) { toast(err.message, true); })
        .finally(function () { addBtn.classList.remove('is-loading'); addBtn.textContent = label; });
      return;
    }
    if (!e.target.closest('[data-sf-card]')) {
      document.querySelectorAll('[data-sf-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sf-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
  });

  window.SFStore = { add: add, toast: toast, refreshBubble: refreshBubble };
})();
